<template>
  <div>
    <button @click="getItems">Get Users</button>
    <div v-for="user in users" :key="user.id">      
      <h4>{{ user.id }} || {{ user.name }}</h4>            
    </div>
    <h3 class="error" v-if="errorMsg">{{ errorMsg }}</h3>
    <div v-for="songs in songRegs" :key="songs.title">      
      <h4>{{ user.id }} || {{ user.name }}</h4>            
    </div>
    <button @click="getSongRegItems">Get Song Registrations</button>
  </div>
</template>

<script>
// import axios from 'axios'
import { restapi } from '../libs/restapi.mjs'

export default {
  name: 'GetItems',
  
  data() {
    return {
      users: [],
      songRegs: [],
      errorMsg: '',
    }
  },
  methods: {
    async getItems() {
      const retVal = await restapi.getAllItemsA();
      if(retVal.errorData.errorMsg != null) {
        this.errorMsg = retVal.errorData.errorMsg;
      } else {
        this.users = retVal.data.users;
      }
    },
    async getSongRegItems() {
      const retVal = await restapi.getAllSongRegItemsA();
      if(retVal.errorData.errorMsg != null) {
        this.errorMsg = retVal.errorData.errorMsg;
      } else {
        this.songRegs = retVal.data.items;
      }
    },
  },
}
</script>

<style scoped>

</style>